import * as React from 'react';
import IconBase, { IconBaseProps } from '../components/Icons/IconBase';
const props = {};

const SvgPhone = (allProps: IconBaseProps) => {
  return (
    <IconBase {...allProps}>
      <svg
        width="1em"
        height="1em"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <path
          d="M14.5333 20.6583L14.5433 20.6642C15.4284 21.2277 16.4793 21.4725 17.5223 21.3581C18.5653 21.2437 19.5381 20.777 20.28 20.035L20.925 19.39C21.2131 19.1016 21.3749 18.7106 21.3749 18.3029C21.3749 17.8953 21.2131 17.5043 20.925 17.2158L18.2075 14.5C17.9191 14.2119 17.5281 14.0501 17.1204 14.0501C16.7128 14.0501 16.3218 14.2119 16.0333 14.5V14.5C15.8907 14.6428 15.7213 14.7561 15.5348 14.8334C15.3484 14.9107 15.1485 14.9505 14.9467 14.9505C14.7448 14.9505 14.545 14.9107 14.3585 14.8334C14.172 14.7561 14.0026 14.6428 13.86 14.5L9.51167 10.1508C9.2236 9.8624 9.06179 9.47141 9.06179 9.06375C9.06179 8.6561 9.2236 8.26511 9.51167 7.97667V7.97667C9.65449 7.83403 9.76779 7.66464 9.84509 7.47818C9.92239 7.29172 9.96218 7.09185 9.96218 6.89001C9.96218 6.68816 9.92239 6.48829 9.84509 6.30183C9.76779 6.11537 9.65449 5.94598 9.51167 5.80334L6.79501 3.08334C6.50657 2.79526 6.11558 2.63345 5.70792 2.63345C5.30027 2.63345 4.90928 2.79526 4.62084 3.08334L3.97584 3.72834C3.23403 4.47032 2.76735 5.44304 2.65282 6.48597C2.53828 7.5289 2.78274 8.57972 3.34584 9.46501L3.35251 9.47501C6.33035 13.8832 10.1258 17.6795 14.5333 20.6583V20.6583Z"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </IconBase>
  );
};

SvgPhone.displayName = 'SvgPhone';
export default SvgPhone;
